import { Controller } from "stimulus";

export default class extends Controller {

    connect() {
        const controller = this;
        let elementForm = $(controller.element);
        elementForm = elementForm[0];
        $('.error-msg').hide();
        $(controller.element).on('input', {elementForm}, this.eventHandler.bind(this));
        $(controller.element).on('change', {elementForm}, this.eventHandler.bind(this));

        elementForm.addEventListener('submit', (event, options) => {

            options = options || {};
            if ( !options.validationChecked ) {
                var requiredElements = $(elementForm).find('.required-element');
                let isValid = true;
                event.preventDefault();

                requiredElements.each(function (key,validationElement){
                    validationElement = $(validationElement);
                    var errorTag = $(elementForm).find('.error-msg[data-element="' + validationElement.attr('id') + '"]');
                    if(errorTag.length === 0){
                        errorTag = validationElement.parents('.form-group').find('.error-msg');
                    }
                    if(errorTag.length === 0){
                        errorTag = validationElement.parents('.form-group').next('.error-msg');
                    }
                    if(validationElement.is('input')){
                        var elementType = validationElement.attr('type');
                        if (elementType === 'text' || elementType === 'email' || elementType === 'tel') {
                            if (validationElement.val() === '') {
                                errorTag.show();
                                isValid = false;
                            }
                        }
                        if (elementType === 'checkbox') {
                            if (!validationElement.is(':checked')) {
                                errorTag.show();
                                isValid = false;
                            }
                        }
                    }
                    if(validationElement.is('select') || validationElement.is('textarea')){
                        if (validationElement.val() === '') {
                            errorTag.show();
                            isValid = false;
                        }
                    }

                })
                if(isValid){
                    $(elementForm).trigger('submit', { 'validationChecked': true });
                }
            }
        });
    }

    eventHandler(event) {
        const elementForm = event.data.elementForm;
        $('.error-msg').hide();
        $(elementForm).find('[type="submit"]').removeAttr('disabled');
    }
}
